module.exports = __webpack_public_path__ + "static/media/dice-d12.2e96d5d7.svg";